export function getClosest(elem, selector) {
  while (elem !== document.body) {
    elem = elem.parentElement;
    if (elem.matches(selector)) return elem;
  }
}
